
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <path d="M10 5H5.5C3.567 5 2 6.567 2 8.5V8.5C2 10.433 3.567 12 5.5 12H8M8 12V12C8 13.1046 8.89543 14 10 14H14C15.1046 14 16 13.1046 16 12V12M8 12V12C8 10.8954 8.89543 10 10 10H14C15.1046 10 16 10.8954 16 12V12M16 12H18.5C20.433 12 22 13.567 22 15.5V15.5C22 17.433 20.433 19 18.5 19H14"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiSystemConnector",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
